// import React, { useState, useEffect, useRef } from "react";

// const ServiceSuggestion = ({ 
//   data, 
//   handleServiceSuggestedClick,
//   onAddNewClick,
//   showAddNew,
//   focusedIndex,
//   setFocusedIndex
// }) => {
//   const [hoveredItem, setHoveredItem] = useState(null);
//   const containerRef = useRef(null);

//   // Scroll to focused item
//   useEffect(() => {
//     if (focusedIndex !== null && containerRef.current) {
//       const items = containerRef.current.querySelectorAll('[data-item]');
//       if (items[focusedIndex]) {
//         items[focusedIndex].scrollIntoView({
//           behavior: 'smooth',
//           block: 'nearest'
//         });
//       }
//     }
//   }, [focusedIndex]);

//   const handleClick = (item, e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     if (item === 'addNew') {
//       onAddNewClick();
//     } else {
//       handleServiceSuggestedClick(item);
//     }
//   };

//     const itemStyle = {
//     display: "flex",
//     justifyContent: "space-between",
//     padding: "8px",
//     cursor: "pointer",
//     borderBottom: "1px solid #eee",
//   };

//   return (
//     <div 
//       ref={containerRef}
//       style={{
//         position: "absolute",
//         backgroundColor: "#fff",
//         border: "1px solid #ccc",
//         zIndex: 1000,
//         maxHeight: "300px",
//         overflowY: "auto",
//         boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//         width: "250px",
//         borderRadius: "4px",
//       }}
//     >
//       {data.map((service, index) => (
//         <div
//           key={service._id}
//           data-item
//           onClick={(e) => handleClick(service, e)}
//           style={{
//             ...itemStyle,
//             padding: "8px 12px",
//             cursor: "pointer",
//             backgroundColor: hoveredItem === index || focusedIndex === index 
//               ? "#6174DD" 
//               : "white",
//             color: hoveredItem === index || focusedIndex === index 
//               ? "white" 
//               : "black",
//           }}
//           onMouseEnter={() => {
//             setHoveredItem(index);
//             setFocusedIndex(index);
//           }}
//           onMouseLeave={() => setHoveredItem(null)}
//         >
//              <span>{service.serviceName}</span>
//              <span>₹{service.price}</span>
//         </div>
//       ))}
//       {showAddNew && (
//         <div
//           data-item
//           onClick={(e) => handleClick('addNew', e)}
//           style={{
//             padding: "8px 12px",
//             cursor: "pointer",
//             backgroundColor: hoveredItem === data.length || focusedIndex === data.length 
//               ? "#6174DD" 
//               : "white",
//             color: hoveredItem === data.length || focusedIndex === data.length 
//               ? "white" 
//               : "#007bff",
//             fontWeight: "bold",
//             textAlign: "center",
//           }}
//           onMouseEnter={() => {
//             setHoveredItem(data.length);
//             setFocusedIndex(data.length);
//           }}
//           onMouseLeave={() => setHoveredItem(null)}
//         >
//           ➕ Add New Service
//         </div>
//       )}
//     </div>
//   );
// };

// export default ServiceSuggestion;



import React, { useState, useEffect, useRef } from "react";

const ServiceSuggestion = ({
  data,
  handleServiceSuggestedClick,
  onAddNewClick,
  showAddNew,
  focusedIndex,
  setFocusedIndex,
  searchValue
}) => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const containerRef = useRef(null);

  // Auto-scroll to focused item
  useEffect(() => {
    if (focusedIndex !== null && containerRef.current) {
      const items = containerRef.current.querySelectorAll("[data-item]");
      if (items[focusedIndex]) {
        items[focusedIndex].scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }
    }
  }, [focusedIndex]);

  const handleClick = (item, e) => {
    e.preventDefault();
    e.stopPropagation();

    if (item.type === "addNew") {
        onAddNewClick(searchValue); 
    } else if (item.type === "service") {
      handleServiceSuggestedClick(item);
    }
  };

  return (
    <div
      ref={containerRef}
      className="service-suggestion-container"
      style={{
        position: "absolute",
        backgroundColor: "#fff",
        border: "1px solid #ccc",
        zIndex: 1000,
        maxHeight: "300px",
        overflowY: "auto",
        width: "260px",
        borderRadius: "5px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
      }}
    >
      {data.map((item, index) => {
        if (item.type === "category") {
          return (
            <div
              key={`cat-${item.name}-${index}`}
              style={{
                fontWeight: "bold",
                padding: "8px 10px",
                backgroundColor: "#f8f8f8",
                borderBottom: "1px solid #ddd",
                position: "sticky",
                top: 0,
                zIndex: 1,
                color: "black", // Ensure category text is black
              }}
            >
              {item.name}
            </div>
          );
        }
        
        if (item.type === "service") {
          const isHoveredOrFocused = hoveredItem === index || focusedIndex === index;
          
          return (
            <div
              key={item._id}
              data-item
              onClick={(e) => handleClick(item, e)}
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "8px 12px",
                cursor: "pointer",
                borderBottom: "1px solid #eee",
                backgroundColor: isHoveredOrFocused ? "#6174DD" : "white",
                color: isHoveredOrFocused ? "white" : "black", // Black by default, white on hover/focus
              }}
              onMouseEnter={() => setHoveredItem(index)}
              onMouseLeave={() => setHoveredItem(null)}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span>{item.serviceName}</span>
                {item.isTopService && (
                  <span style={{ 
                    fontSize: "12px", 
                    color: isHoveredOrFocused ? "white" : "#0e0d0dff" // Dark gray by default, white on hover
                  }}>
                    {item.category}
                  </span>
                )}
                {!item.isTopService && item.displayCategory && item.displayCategory !== "Frequently Used" && (
                  <span style={{ 
                    fontSize: "12px", 
                    color: isHoveredOrFocused ? "white" : "#121111ff" // Dark gray by default, white on hover
                  }}>
                    {item.displayCategory}
                  </span>
                )}
              </div>
              <span>₹{item.price}</span>
            </div>
          );
        }
        
        if (item.type === "addNew") {
          const isHoveredOrFocused = hoveredItem === index || focusedIndex === index;
          
          return (
            <div
              key="addNew"
              data-item
              onClick={(e) => handleClick(item, e)}
              style={{
                padding: "10px 12px",
                cursor: "pointer",
                backgroundColor: isHoveredOrFocused ? "#6174DD" : "white",
                color: isHoveredOrFocused ? "white" : "#007bff", // Blue by default, white on hover
                fontWeight: "bold",
                textAlign: "center",
              }}
              onMouseEnter={() => setHoveredItem(index)}
              onMouseLeave={() => setHoveredItem(null)}
            >
              ➕ Add New Service
            </div>
          );
        }
        
        return null;
      })}
    </div>
  );
};

export default ServiceSuggestion;

